import { render, staticRenderFns } from "./MenuCompany.vue?vue&type=template&id=72ac4966&scoped=true&"
import script from "./MenuCompany.vue?vue&type=script&lang=js&"
export * from "./MenuCompany.vue?vue&type=script&lang=js&"
import style0 from "./MenuCompany.vue?vue&type=style&index=0&id=72ac4966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac4966",
  null
  
)

export default component.exports